(function Tabs() {
    /**
     * Contains the logic for switching between tabs
     * and activating default tabs
     * @constructor
     */
    function TabMenu() {

        //sets context
        _this = this;

        /**
         * Initializes Default settings and event listeners
         */
        this.init = function () {
            _this.selectDefault();
            _this.addListenersForTabs();
        };

        /**
         * Activates the first header and content in all TabMenus on the page
         */
        this.selectDefault = function () {
            var allHeaders = document.querySelectorAll('[data-tab-menu-header]');
            var allContentElements = document.querySelectorAll('[data-tab-menu-content]');

            //Sets Default values to display the first tab content in every tab menu
            allHeaders.forEach(function (header) {
                if (header.getAttribute('data-tab-menu-id') === '1') {
                    header.classList.add('tab-menu--tab-header-active');
                }
            });
            allContentElements.forEach(function (element) {
                element.classList.add('tab-menu--tab-content-hidden');
                if (element.getAttribute('data-tab-menu-id') === '1') {
                    element.classList.remove('tab-menu--tab-content-hidden')
                }
            });
        };

        /**
         * Sets classes according to the selected tabs
         * Adds a click event listener for each tab menu and each tab
         */
        this.addListenersForTabs = function () {
            var tabMenus = document.querySelectorAll('[data-tab-menu-wrapper]');
            tabMenus.forEach(function (tabMenu) {
                var headers = tabMenu.querySelectorAll('[data-tab-menu-header]');
                var contentElements = tabMenu.querySelectorAll('[data-tab-menu-content]');
                headers.forEach(function (header, index, headers) {
                    header.addEventListener('click', function () {
                        clickedId = header.getAttribute('data-tab-menu-id');
                        headers.forEach(function (headerToSetInavtive) {
                            headerToSetInavtive.classList.remove('tab-menu--tab-header-active');
                        });
                        header.classList.add('tab-menu--tab-header-active');
                        contentElements.forEach(function (element) {
                            if (!element.classList.contains('tab-menu--tab-content-hidden')) {
                                element.classList.add('tab-menu--tab-content-hidden');
                            }
                            if (element.getAttribute('data-tab-menu-id') === clickedId) {
                                element.classList.remove('tab-menu--tab-content-hidden')
                            }
                        });
                    });
                });
            });
        };
    }
    if(typeof window.TechDivisionStructure === 'undefined') {
        window.TechDivisionStructure = {};
    }
    window.TechDivisionStructure.TabMenu = TabMenu;
})();

/**
 * Initialize the TabMenu on page load
 */
document.addEventListener("DOMContentLoaded", function (event) {
    //To make NodeList.forEach() method work on internet explorer
    //START OF Internet explorer polyfill
    if ( typeof NodeList.prototype.forEach !== "function" ) {
        NodeList.prototype.forEach = Array.prototype.forEach;
        console.log('polyfill is running!');
    }
    //END OF Internet explorer polyfill

    tabMenu = new window.TechDivisionStructure.TabMenu();
    tabMenu.init();
});
